// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { CloseIcon, Button, Text, LinkExternal } from '@pancakeswap/uikit';
import React from 'react';
import styled from 'styled-components';

interface GetSymbolModalProps {
    onClose: () => void;
    open: boolean;
}

const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    // border-bottom: 1px solid #00FED9;
    display: flex;
    padding: 24px 24px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ModalBody = styled(Box)`
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    padding: 24px;
`

const BuyButton = styled.a`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  /* line-height: 1.5; */
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px !important;
  padding: 0px 20px;
  width: 100%;
  background-color: #00FED9;
  color: black;
  margin-top: 24px;
  font-weight: 600;
  font-size: 20px;
  ${({ theme }) => theme.mediaQueries.xs} {
    height: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
`;


const PLinkExternal = styled(LinkExternal)`
  text-decoration : none !important;
  border:2px solid #00FED9  !important;
  border-radius: 20px;
  justify-content: center;
  color: #00FED9 !important;
  height:48px;
  line-height:1;
  opacity:1;
  font-weight: 600;
  font-size: 16px !important;
  min-width:48px !important;
  width:100%;
  padding:0px !important;
  margin-top: 20px;
  &:hover {
    opacity: 0.8;
  }
`

const CloseButton = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    color: white;
    box-shadow: none;

`

const GetSymbolModal: React.FunctionComponent<GetSymbolModalProps> = ({
    open,
    onClose,

}) => {
    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        // left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                        left: { xl: '50%', lg: '50%', md: '50%', sm: '50%', xs: '50%' }
                    }}>
                    <Box sx={{
                        width: 'auto',
                        // py: 4,
                        background: '#1A3342',
                        // boxShadow: 'rgba(14, 14, 44, 0.1) 0px 20px 36px -8px, rgba(0, 0, 0, 0.05) 0px 1px 1px',
                        borderRadius: '32px',
                        maxWidth: '525px',
                        // minWidth:'380px',
                        minWidth: { xl: '730px', lg: '730px', md: '600px', sm: '600px', xs: '380px' },
                        maxHeight: '100vh',
                        zIndex: '100'
                        // minWidth: '500px'
                    }}>
                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        color: '#00FED9',
                                    }}>
                                    DRIVENx required
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>

                        <ModalBody>
                            <Text color='rgb(248, 113, 113)' fontSize='16px' fontWeight={600} lineHeight={1.5}>
                                Insufficient DRIVENx balance
                            </Text>
                            <Text color='#00FED9' marginTop={'24px'} fontSize='16px' fontWeight={400} lineHeight={1.5} >
                                You’ll need DRIVENx to stake in this pool!
                            </Text>
                            <Text color='#00FED9' fontSize='16px' fontWeight={400} lineHeight={1.5} >
                                Buy some DRIVENx, or make sure your DRIVENx isn’t in another pool or LP.
                            </Text>

                            <BuyButton href='https://pancakeswap.finance/swap?outputCurrency=0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e' target="_blank">
                                Buy DRIVENx
                            </BuyButton>
                            <PLinkExternal href={''} bold={false} color='#00FED9'>
                                <Text fontSize="16px" color='#00FED9' >
                                    Locate Assets
                                </Text>
                            </PLinkExternal>

                            <CloseButton onClick={onClose}>
                                Close Window
                            </CloseButton>
                        </ModalBody>


                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default GetSymbolModal;
